import svgIcons from "../../../shared/constants/icons/svg-icons";
import routesNames from "../../../shared/constants/router";
import roles from "../../../shared/constants/roles";
import permissions from "../../../shared/constants/permissions";
import {pages} from "../../../shared/constants/pages";

const menu = {
  timesheets: {
    name:pages.menu.timesheets,
    icon:svgIcons.timesheets,
    url: routesNames.timesheets,
    roles: [roles.WORKER, roles.APPROVER],
  },
  invoices: {
    name:pages.menu.invoices,
    icon:svgIcons.invoices,
    url: routesNames.invoices,
    roles: [roles.VENDOR],
  },
  vendor_timesheet: {
    name:pages.menu.timesheets,
    icon:svgIcons.timesheets,
    url: routesNames.vendortimesheets,
    roles: [roles.VENDOR],
  },
  help_center: {
    name: pages.menu.help_center,
    icon: svgIcons.help_center,
    url: routesNames.help.help,
    roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN, roles.WORKER, roles.APPROVER]
  },
  timesheets_freelancer: {
    name: pages.menu.homepage,
    icon: svgIcons.homepage,
    url: routesNames.timesheets,
    roles: [roles.FREELANCER]
  },
  administration: {
    name: pages.menu.administration,
    icon: svgIcons.settings,
    roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
    children: {
      scopes: {
        name: pages.menu.scopes,
        icon: svgIcons.scope,
        url: routesNames.administration.scopes
      },
      users: {
        name: pages.menu.users,
        icon: svgIcons.personal_details,
        url: routesNames.administration.users,
        permissions: [permissions.readAllUsers]
      },
      permissions: {
        name: pages.menu.permissions,
        icon: svgIcons.security,
        url: routesNames.administration.permissions,
        permissions: [permissions.assignPermissions, permissions.readAllPermissions]
      },
      languages: {
        name: pages.menu.languages,
        icon: svgIcons.dashboard,
        url: routesNames.administration.languages,
        roles: [roles.SUPER_ADMIN, roles.LOCAL_ADMIN],
      },
      logs: {
        name: pages.menu.logs,
        icon: svgIcons.logs,
        url: routesNames.administration.logs,
        permissions: [permissions.readAllActivities]
      },
      jobs_logs: {
        name: pages.menu.jobs_logs,
        icon: svgIcons.jobs_logs,
        url: routesNames.administration.jobsLogs,
        permissions: [permissions.readAllActivities]
      },
      vendor: {
        name:pages.menu.vendor,
        icon:svgIcons.vendor,
        url: routesNames.vendorDashboard,
        permissions: [permissions.readAllVendorTimesheets, permissions.readAllInvoices],
      },
      client: {
        name:pages.menu.client,
        icon:svgIcons.client,
        url: routesNames.administration.clients,
        permissions: [permissions.readAllClients],
      },
    }
  }
}
export default menu
